/** Auxiliares para assinar stores do Zustand fora do React. */
import type { StoreApi } from 'zustand';

/**
 * Chama `listener` quando o valor selecionado muda (comparação por `equals`,
 * padrão `Object.is`). Retorna o cancelamento.
 */
export function subscribeSelector<S, T>(
  store: Pick<StoreApi<S>, 'subscribe' | 'getState'>,
  selector: (state: S) => T,
  listener: (value: T, previous: T) => void,
  equals: (a: T, b: T) => boolean = Object.is,
): () => void {
  let current = selector(store.getState());
  return store.subscribe((state) => {
    const next = selector(state);
    if (equals(next, current)) return;
    const previous = current;
    current = next;
    listener(next, previous);
  });
}

/** Igualdade rasa de arrays. */
export function shallowArrayEqual<T>(a: readonly T[], b: readonly T[]): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (!Object.is(a[i], b[i])) return false;
  return true;
}
